<template>
  <div style="background: #fff; padding: 20px; border-radius: 20px;">
    <!-- 顶部板块 -->
    <el-card class="top-card">
      <el-row>
        <el-col :span="6">
          <span style="display: inline-block; margin-right: 8px;">设备名称</span>
          <el-select v-model="deviceName" placeholder="请选择设备名称" style="width: calc(100% - 80px);">
            <el-option
              v-for="item in deviceNameOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-col>

        <el-col :span="9">
          <div style="display: flex; align-items: center;">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 100%; margin-right: 8px;"
            ></el-date-picker>
            <el-button type="primary" @click="filterRepairs">搜索</el-button>
          </div>
        </el-col>
        
      </el-row>
    </el-card>

    <!-- 卡片式报修列表 -->
    <div class="card-list-container">
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in paginatedRepairs" :key="item.repairNumber">
          <el-card class="repair-card" shadow="hover">
            <el-button class="delete-btn" type="text" icon="el-icon-delete" @click="confirmDelete(item)"></el-button>
            <div class="card-header">
              <div class="card-id">ID: {{ item.repairNumber }}</div>
            </div>
            <div class="card-device-row">
              <span class="device-link">{{ item.device }}</span>
              <div class="card-status">
                <el-tag :type="item.status === '已审核' ? 'success' : 'info'" size="mini">状态：{{ item.status }}</el-tag>
              </div>
            </div>
            <div class="card-reporter left-align">报修人或机构：{{ item.reporter }}</div>
            <div class="card-img-wrap">
              <img :src="item.fileUrl || '/static/icons/default.png'" class="repair-img" alt="问题图片" />
            </div>
            <div class="card-description-wrap left-align">
              <span class="card-description"
                    :title="item.description.length > 10 ? item.description : ''">
                报修描述：{{ item.description.length > 10 ? (item.description.slice(0, 10) + '...') : item.description }}
              </span>
            </div>
            <div class="card-time left-align">报修时间：{{ item.repairTime }}</div>
            <div class="card-actions" v-if="item.status !== '已审核'">
              <el-button type="success" size="mini" @click="confirmReview(item)">确认审核</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-pagination
      v-if="filteredRepairs.length > pageSize"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="filteredRepairs.length">
    </el-pagination>

    
  </div>
</template>

<script>
import axios from 'axios'; // 保留原有接口方式，如需用request可切换

export default {
  data() {
    return {
      deviceName: '', // 设备名称筛选
      dateRange: [],
      newRepair: {
        device: '',
        reporter: '',
        description: '',
        adr: ''
      },
      fileList: [],
      repairs: [], // 所有报修记录
      filteredRepairs: [], // 过滤后的报修记录
      currentPage: 1,
      pageSize: 6,
    };
  },
  computed: {
    deviceNameOptions() {
      // 从当前 repairs 列表中提取唯一设备名称
      const names = this.repairs.map(r => r.device).filter(Boolean);
      return [...new Set(names)];
    },
    paginatedRepairs() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredRepairs.slice(start, start + this.pageSize);
    },
  },
  created() {
    this.fetchRepairs(); // 组件创建时从后端获取数据
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    // 获取报修数据
    fetchRepairs() {
      const accountNum = localStorage.getItem('agentUserInfo').replace(/^"|"$/g, '');
      axios.get(`/api/maintenanceTable/selectAll?accountNum=${accountNum}`)
        .then(response => {
          if (response.data.code === 0) {
            this.repairs = response.data.data.map(item => ({
              repairNumber: item.id,
              device: item.devidName,
              reporter: item.maintenanceName,
              description: item.maintenanceProblem,
              repairTime: this.formatDate(item.maintenanceTime),
              status: item.maintenanceState === 0 ? '未审核' : '已审核',
              fileUrl: item.url ? `/resources/maintenanceTable/${item.url}` : '/static/icons/default.png',
            }));
            this.filterRepairs(); // 获取数据后执行筛选
          } else {
            this.$message.error('数据获取失败');
          }
        })
        .catch(error => {
          this.$message.error('请求失败');
        });
    },

    // 搜索功能
    filterRepairs() {
      // 搜索功能，支持设备名称和时间段过滤
      this.filteredRepairs = this.repairs.filter(item => {
        const matchDevice = this.deviceName ? item.device === this.deviceName : true;
        const matchDate = this.dateRange.length === 2 ?
          new Date(item.repairTime) >= new Date(this.dateRange[0]) && new Date(item.repairTime) <= new Date(this.dateRange[1]) : true;
        return matchDevice && matchDate;
      });
      this.currentPage = 1;
    },

    // 分页切换
    handleCurrentChange(page) {
      this.currentPage = page;
    },

    // 删除报修记录
    confirmDelete(row) {
      this.$confirm('确定要删除该报修记录吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/api/maintenanceTable/deleteById?id=${row.repairNumber}`).then(response => {
          if (response.data.success) {
            this.$message.success('删除成功');
            this.fetchRepairs(); // 获取报修数据
          } else {
            this.$message.error('删除失败');
          }
        });
      });
    },

    // 确认审核
    confirmReview(row) {
      this.$confirm('确定要确认审核该报修记录吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(`/apimaintenanceTable/update?id=${row.repairNumber}`)
          .then(response => {
            if (response.data.success) {
              this.$message.success('确认审核成功');
              this.fetchRepairs(); // 获取报修数据
            } else {
              this.$message.error('确认审核失败');
            }
          });
      });
    },

    resetForm() {
      this.newRepair.device = '';
      this.newRepair.reporter = '';
      this.newRepair.description = '';
      this.newRepair.adr = '';
      this.fileList = [];
      this.dateRange = [];
    },

    // 文件上传相关
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },

    // eslint-disable-next-line no-unused-vars
    handleExceed(files, fileList) {
      this.$message.warning('最多只能上传 5 个文件');
    },

    beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
      }
      return isImage;
    },
  },
};
</script>

<style scoped>
.top-card {
  margin-bottom: 20px;
  padding: 20px;
  box-shadow: none !important;
  border: none !important;
}
.card-list-container {
  min-height: 400px;
}
.repair-card {
  border-radius: 12px;
  margin-bottom: 20px;
  position: relative;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: box-shadow .2s;
  box-shadow: 0 2px 12px rgba(0,0,0,0.2);
}
.card-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2px;
  min-height: 28px;
}
.card-id {
  font-size: 15px;
  color: #333;
  flex-shrink: 0;
  line-height: 1;
}
.card-device-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  min-height: 26px;
}
.device-link {
  font-size: 17px;
  font-weight: 500;
  color: #2EA2FA;
  text-align: left;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-status {
  font-size: 13px;
  flex-shrink: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 20px;
}
.left-align {
  text-align: left !important;
}
.card-reporter {
  color: #333;
  font-size: 14px;
  margin-bottom: 8px;
}
.card-img-wrap {
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
  background: #fafbfc;
  border-radius: 10px;
  padding: 12px 0 8px 0;
  min-height: 110px;
}
.repair-img {
  max-width: 90%;
  max-height: 240px;
  border-radius: 8px;
  background: #f6f6f6;
  object-fit: contain;
}
.card-description-wrap {
  margin-bottom: 6px;
  min-height: 22px;
}
.card-description {
  color: #333;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 95%;
}
.card-time {
  color: #333;
  font-size: 13px;
  margin-bottom: 6px;
}
.delete-btn {
  position: absolute;
  top: 12px;
  right: 10px;
  color: #bfbfbf;
  z-index: 10;
  font-size: 18px;
}

@media (max-width: 1400px) {
  .card-list-container .el-col-6 {
    width: 33.3333% !important;
    max-width: 33.3333%;
    flex: 0 0 33.3333%;
  }
}
@media (max-width: 1100px) {
  .card-list-container .el-col-6 {
    width: 50% !important;
    max-width: 50%;
    flex: 0 0 50%;
  }
}
@media (max-width: 700px) {
  .card-list-container .el-col-6 {
    width: 100% !important;
    max-width: 100%;
    flex: 0 0 100%;
  }
  .repair-card {
    min-width: 240px;
  }
}
</style>